import { Button } from "@/components/ui/primitives";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 text-center">
      <p className="text-gradient text-8xl font-black leading-none tabular-nums">404</p>
      <h1 className="mt-4 text-2xl font-extrabold tracking-tight text-text">
        Page not found
      </h1>
      <p className="mt-3 text-text-muted">
        The page you&apos;re looking for doesn&apos;t exist or may have moved.
      </p>
      <div className="mt-8">
        <Link to="/">
          <Button variant="primary" size="lg">
            Back to home
          </Button>
        </Link>
      </div>
    </div>
  );
}
